/* Shared enhancements for the design studio (all promotions) and Shopify draft. */
(()=>{
  const strips=new Set(),announcements=new WeakSet();
  let queued=false;
  const sizeStrip=strip=>{
    const width=strip.clientWidth,count=strip.children.length,gap=10,target=120;
    if(!width||!count)return;
    const full=Math.max(2,Math.floor((width+gap)/(target+gap)-.5));
    let card=count*target+(count-1)*gap<=width?target:(width-full*gap)/(full+.5);
    if(matchMedia('(max-width:600px)').matches){
      // Stay close to the 78px clasp swatches; vary only a few pixels for a clear next-card cue.
      const sizes=Array.from({length:9},(_,i)=>84+i).sort((a,b)=>Math.abs(a-88)-Math.abs(b-88));
      card=sizes.find(size=>{const visible=(width-Math.floor(width/(size+gap))*(size+gap))/size;return visible>=.2&&visible<=.8})||88;
    }
    const value=card.toFixed(3)+'px';
    if(strip.style.getPropertyValue('--adapter-card-width')!==value)strip.style.setProperty('--adapter-card-width',value);
    // Hardware finishes inherit the adapter's measured size, including its partial-card cue.
    const details=strip.closest('.product-details');
    if(details&&details.style.getPropertyValue('--adapter-card-width')!==value)details.style.setProperty('--adapter-card-width',value);
  };
  const resize=new ResizeObserver(entries=>entries.forEach(({target})=>sizeStrip(target)));
  function labelFinishes(strip){
    for(const label of strip.querySelectorAll('.adapter-option>span:not(.adapter-thumbnail):not(.adapter-finish-label)')){
      const text=label.textContent,match=text.match(/Natural Titanium|Space Black|Rose Gold|Silver|Gold|Black|Starlight|Midnight|Graphite|Blue|White/i);
      if(!match)continue;
      const surface=document.createElement('span'),color=document.createElement('strong');
      surface.className='adapter-finish-surface';surface.textContent=text.slice(0,match.index).trim();
      color.className='adapter-finish-color';color.textContent=match[0];
      label.classList.add('adapter-finish-label');label.replaceChildren();
      if(surface.textContent)label.append(surface);
      label.append(color,document.createTextNode(text.slice(match.index+match[0].length)));
    }
  }
  const draggable=new WeakSet();
  function enableDrag(strip){
    if(!strip||draggable.has(strip)||strip.hasAttribute('data-flickity-slider'))return;
    draggable.add(strip);strip.classList.add('storefront-slider');
    const active=strip.querySelector('.photo-option.active');
    if(active){const a=active.getBoundingClientRect(),r=strip.getBoundingClientRect();if(a.right>r.right)strip.scrollLeft+=a.right-r.right;else if(a.left<r.left)strip.scrollLeft+=a.left-r.left}

    let press=null,suppressClick=false;
    strip.addEventListener('pointerdown',e=>{
      if(e.pointerType!=='mouse'||e.button!==0||strip.scrollWidth<=strip.clientWidth+1)return;
      press={id:e.pointerId,x:e.clientX,y:e.clientY,lastX:e.clientX,time:e.timeStamp,scroll:strip.scrollLeft,velocity:0,dragged:false};suppressClick=false;
    });
    strip.addEventListener('pointermove',e=>{
      if(!press||e.pointerId!==press.id)return;
      const dx=e.clientX-press.x,dy=e.clientY-press.y;
      if(!press.dragged&&(Math.abs(dx)<6||Math.abs(dx)<Math.abs(dy)))return;
      if(!press.dragged){press.dragged=true;strip.setPointerCapture(press.id);strip.classList.add('is-dragging')}
      const dt=e.timeStamp-press.time;
      if(dt>0)press.velocity=(press.lastX-e.clientX)/dt;
      press.lastX=e.clientX;press.time=e.timeStamp;
      e.preventDefault();strip.scrollLeft=press.scroll-dx;
    });
    const end=e=>{
      if(!press)return;
      const p=press;press=null;suppressClick=p.dragged;
      strip.classList.remove('is-dragging');
      if(p.dragged&&e.type==='pointerup'){
        const velocity=e.timeStamp-p.time<100?p.velocity:0;
        let target=strip.scrollLeft+Math.max(-450,Math.min(450,velocity*160));
        if(getComputedStyle(strip).scrollSnapType!=='none'){
          const box=strip.getBoundingClientRect(),pad=parseFloat(getComputedStyle(strip).scrollPaddingLeft)||0;
          const points=[...strip.children].map(c=>c.getBoundingClientRect().left-box.left+strip.scrollLeft-pad);
          if(points.length){
            target=points.reduce((a,b)=>Math.abs(b-target)<Math.abs(a-target)?b:a);
            // A deliberate short drag should advance, rather than snapping to the same card.
            if(Math.abs(target-p.scroll)<8&&Math.abs(p.x-p.lastX)>12){
              const next=p.x>p.lastX?points.find(x=>x>p.scroll+8):points.findLast(x=>x<p.scroll-8);
              if(next!==undefined)target=next;
            }
          }
        }
        strip.scrollTo({left:target,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
      }
      setTimeout(()=>{suppressClick=false},0);
    };
    strip.addEventListener('pointerup',end);strip.addEventListener('pointercancel',end);strip.addEventListener('lostpointercapture',end);
    strip.addEventListener('pointerleave',()=>{if(press&&!press.dragged)press=null});
    strip.addEventListener('click',e=>{if(suppressClick){e.preventDefault();e.stopImmediatePropagation()}},true);
    strip.addEventListener('dragstart',e=>e.preventDefault());
    strip.addEventListener('keydown',e=>{
      if(!['ArrowLeft','ArrowRight','Home','End'].includes(e.key)||e.target.closest('input,select,textarea'))return;
      if(strip.scrollWidth<=strip.clientWidth+1)return;
      e.preventDefault();const step=(strip.firstElementChild?.getBoundingClientRect().width||100)+(parseFloat(getComputedStyle(strip).gap)||0);
      strip.scrollTo({left:e.key==='Home'?0:e.key==='End'?strip.scrollWidth:strip.scrollLeft+(e.key==='ArrowLeft'?-step:step),behavior:'smooth'});
    });
  }
  window.LongvadonSliders={enhance:enableDrag};
  // iOS Safari applies :active (the pressed colour on touch screens) only when the page listens for touches.
  document.addEventListener('touchstart',()=>{},{passive:true});
  // Local shell and native Shopify announce their heights differently; keep the hero aligned.
  const alignHero=()=>{
    const hero=document.querySelector('#home-hero');if(!hero)return;
    const top=Math.max(0,hero.getBoundingClientRect().top+scrollY).toFixed(2)+'px';
    if(hero.style.getPropertyValue('--storefront-hero-offset')!==top)hero.style.setProperty('--storefront-hero-offset',top);
  };
  const announcementResize=new ResizeObserver(alignHero);
  // Phones (Robin, October 22): once Add to cart has been scrolled past, the same button floats at the bottom
  // of the screen and fades out when the original is back in view. It replaced the Sticky Buy Now app. Its
  // click goes to the original button, which keeps the add logic, its live checks and its "Adding…" state.
  const phone=matchMedia('(max-width:600px)');
  let floatingAdd=null,addSource=null,addQueued=false;
  const copyAddState=()=>{
    const button=floatingAdd.querySelector('button'),label=addSource.textContent.trim();
    button.disabled=addSource.disabled;
    if(button.textContent!==label)button.firstElementChild.textContent=label;
  };
  const mirrorAdd=new MutationObserver(copyAddState);
  // Shopify's header slides back in when scrolling up and covers the top of the screen: Add to cart counts as
  // back in view only once it shows below the header.
  function coveredTop(){
    for(let el=document.elementFromPoint(innerWidth/2,1);el&&el!==document.body;el=el.parentElement){
      if(!/fixed|sticky/.test(getComputedStyle(el).position))continue;
      const r=el.getBoundingClientRect();return r.top<=1&&r.height<innerHeight*.4?Math.max(0,r.bottom):0;
    }
    return 0;
  }
  function placeFloatingAdd(){
    addQueued=false;
    if(!floatingAdd)return;
    const bar=floatingAdd.firstElementChild,rect=addSource?.getBoundingClientRect();
    const show=!!rect&&phone.matches&&rect.height>0&&(rect.bottom<=0||rect.bottom<innerHeight*.4&&rect.bottom<=coveredTop());
    if(bar.classList.contains('is-visible')===show)return;
    bar.classList.toggle('is-visible',show);
    // Toasts rise above the bar while it shows.
    document.documentElement.style.setProperty('--floating-add-height',show?bar.offsetHeight+'px':'0px');
  }
  const queueFloatingAdd=()=>{if(!addQueued){addQueued=true;requestAnimationFrame(placeFloatingAdd)}};
  function trackAddButton(){
    // The redesigned product page, or the native product form (bags, wallets and watch cases).
    const source=[...document.querySelectorAll('#main .product-add,.main-product-grid [data-addtocart-main]')].find(b=>b.getClientRects().length)||null;
    if(source!==addSource){
      addSource=source;mirrorAdd.disconnect();
      if(source){
        if(!floatingAdd){
          // The wrapper carries the Shopify stylesheet's scope class, so native product pages style the bar too.
          floatingAdd=document.createElement('div');floatingAdd.className='lvd-redesign';
          floatingAdd.innerHTML='<div class="floating-add"><button type="button" class="floating-add-button"><span></span></button></div>';
          floatingAdd.querySelector('button').addEventListener('click',()=>addSource?.click());
          document.body.append(floatingAdd);
        }
        mirrorAdd.observe(source,{attributes:true,attributeFilter:['disabled'],childList:true,characterData:true,subtree:true});
        copyAddState();
      }
    }
    queueFloatingAdd();
  }
  // The header's slide finishes after the last scroll event.
  addEventListener('scroll',queueFloatingAdd,{passive:true});addEventListener('transitionend',queueFloatingAdd,{passive:true});
  // Robin, October 22: card titles take a second line only where a title in the same row wraps, decided row by row
  // in every grid and product row, so the lines under the titles align without a gap under single-line rows.
  function alignCardTitles(){
    const titles=[...document.querySelectorAll('.product-grid>.product-card .card-name')],rows=new Map();
    for(const title of titles)title.style.minHeight='';
    for(const title of titles){
      const card=title.closest('.product-card');if(!card.getClientRects().length)continue;
      const top=Math.round(card.getBoundingClientRect().top),grid=rows.get(card.parentElement)||new Map();rows.set(card.parentElement,grid);
      const row=[...grid.keys()].find(t=>Math.abs(t-top)<=2)??top;
      grid.set(row,[...(grid.get(row)||[]),[title,title.getBoundingClientRect().height]]);
    }
    for(const grid of rows.values())for(const row of grid.values()){
      const tallest=Math.max(...row.map(([,height])=>height));
      for(const [title,height] of row)if(height<tallest-.5)title.style.minHeight=tallest+'px';
    }
  }
  function enhance(){
    queued=false;
    for(const strip of strips)if(!strip.isConnected){resize.unobserve(strip);strips.delete(strip)}
    document.querySelectorAll('.adapter-photos').forEach(strip=>{
      if(!strips.has(strip)){strips.add(strip);labelFinishes(strip);resize.observe(strip)}
      sizeStrip(strip);
    });
    document.querySelectorAll('.home-carousel,.hardware-photos,.product-slider[data-slider],.original-gallery,.models').forEach(enableDrag);
    // Robin, October 22: a collection card opens its link wherever it is pressed. A transparent copy of its Shop now
    // link covers the card (hidden from keyboard and screen readers); enableDrag still turns a drag into scrolling
    // and swallows the click that ends it.
    document.querySelectorAll('.home-collection-card').forEach(card=>{
      const link=card.querySelector('.home-card-link');if(!link||card.querySelector(':scope>.home-card-cover'))return;
      const cover=link.cloneNode(false);cover.className='home-card-cover';cover.removeAttribute('id');cover.setAttribute('aria-hidden','true');cover.tabIndex=-1;card.append(cover);
    });
    document.querySelectorAll('.shell-announcement,.announcement-wrapper').forEach(el=>{if(!announcements.has(el)){announcements.add(el);announcementResize.observe(el)}});
    alignHero();trackAddButton();alignCardTitles();
  }
  const schedule=()=>{if(!queued){queued=true;requestAnimationFrame(enhance)}};
  // Title wrapping can change once web fonts arrive.
  document.fonts?.addEventListener('loadingdone',schedule);
  new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true});
  window.addEventListener('resize',schedule);enhance();
})();
// Robin, October 22: a pop-up opened with a tap showed a focus ring around its close button. showModal() focuses the
// dialog's first control, and Safari then draws the keyboard ring on it. The dialog itself takes the focus instead (it
// is labelled, so screen readers announce it), and Tab still reaches the close button, with its ring, from there.
(()=>{
  const proto=window.HTMLDialogElement?.prototype,show=proto?.showModal;if(!show||show.lvdDialogFocus)return;
  const dismiss='.close-button,[data-close],[aria-label^="Close"]';
  proto.showModal=function(...args){
    const result=show.apply(this,args),active=document.activeElement;
    if(this.contains(active)&&active.matches(dismiss)){if(!this.hasAttribute('tabindex'))this.tabIndex=-1;this.focus({preventScroll:true})}
    return result;
  };
  proto.showModal.lvdDialogFocus=true;
})();
/* Robin, October 22: the offer pop-up (Buy 2, Get 1 Free, or a running promotion's own offer) is one and the same
   wherever it opens: the product page's offer banner (offerHelp() in shop.js) and the cart's ? (cart-offer.js). */
window.LongvadonOfferHelp=(()=>{
  const esc=s=>String(s??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const words=['','one','two','three','four'];
  // The example bands: the straight-on photos of four Caiman Series 3 straps.
  function photos(catalog,photography,count=3){return ['18df4b29f7c9','c4e3e2c549d9','d72ee5e7ea21','88e8b5a26b8d'].slice(0,count).map(id=>{const g=catalog.groups.find(g=>g.id===id);const im=Object.values(photography.products).find(p=>p.groupId===id)?.gallery.find(im=>/_straight1_/.test(im.src));return {src:im?.src||g.image,name:g.name}})}
  // The pop-up's body under its title (the offer's title); photos are sized for it already.
  function markup({offer,occasion='',photos}){
    const pay=offer.bands-offer.free;
    return `${occasion?`<p class="offer-occasion-note"><span class="offer-occasion">${esc(occasion)} only</span> For ${esc(occasion)}, ${esc(offer.title)} replaces our usual Buy 2, Get 1.</p>`:''}<p class="offer-intro">Add any ${offer.bands} bands to your bag.</p><div class="offer-example" style="--offer-bands:${offer.bands}" aria-label="${offer.bands===3?'Three':'Four'} bands: pay for the first two, get the lowest-priced ${words[offer.free]} free">${photos.map((im,i)=>`<figure class="offer-band ${i>=pay?'offer-band-free':''}"><span class="offer-band-number" aria-hidden="true">${i+1}</span><img src="${esc(im.src)}" alt="${esc(im.name)}"></figure>`).join('')}<div class="offer-pay-label">Pay for ${pay}</div><div class="offer-free-label"${offer.free>1?` style="grid-column:span ${offer.free}"`:''}>Get ${offer.free} free</div></div><div class="offer-checkout"><span aria-hidden="true">✓</span><strong>Applied automatically at checkout</strong></div><p class="offer-terms">${offer.free>1?`The ${words[offer.free]} lowest-priced bands are free.`:'The lowest-priced band is free.'} No code needed.</p>${offer.code?`<p class="offer-terms">Or enter <b class="offer-code">${esc(offer.code)}</b> at checkout for 30% off. Choose one offer: they can’t be combined.</p>`:''}<button class="primary-button" data-close="help">Got it</button>`;
  }
  return {photos,markup};
})();
// Robin, October 22: "Know more" on the footer's shipping and warranty cards (every Shopify page) opens the site's
// quick pop-up, not the theme's side drawer. The drawer's own content moves into the pop-up while it is open, so its
// country picker keeps working, and moves back when it closes. The studio's cards already open the app's pop-up.
(()=>{
  let dialog,source;
  const make=()=>{
    const host=document.createElement('div');host.className='lvd-redesign lvd-know-more';
    host.innerHTML='<dialog class="help-dialog drawer-help" aria-labelledby="lvd-know-more-title"><div class="drawer-head"><h2 id="lvd-know-more-title"></h2><button class="close-button" type="button" aria-label="Close">×</button></div><div class="ps-drawer-content lvd-know-more-body"></div></dialog>';
    document.body.append(host);dialog=host.querySelector('dialog');
    dialog.querySelector('.close-button').addEventListener('click',()=>dialog.close());
    // A press that starts and ends outside the box closes it, as the app's pop-ups do.
    let outside=false;const out=e=>{const r=dialog.getBoundingClientRect();return e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom};
    dialog.addEventListener('pointerdown',e=>{outside=e.target===dialog&&out(e)});
    dialog.addEventListener('click',e=>{if(outside&&e.target===dialog&&out(e))dialog.close();outside=false});
    dialog.addEventListener('close',()=>{const body=dialog.querySelector('.lvd-know-more-body');if(source)while(body.firstChild)source.append(body.firstChild);source=null});
  };
  document.addEventListener('click',e=>{
    const link=e.target.closest?.('a[data-sidedrawer-open][href^="#popup-image_"]'),drawer=link&&document.querySelector(link.getAttribute('href'));
    const content=drawer?.querySelector('.side-drawer-modal-body');if(!content)return;
    e.preventDefault();e.stopPropagation();if(!dialog)make();if(dialog.open)return;
    dialog.querySelector('h2').textContent=drawer.querySelector('.side-drawer-modal-title')?.textContent.trim()||link.textContent.trim();
    const body=dialog.querySelector('.lvd-know-more-body');source=content;while(content.firstChild)body.append(content.firstChild);
    dialog.showModal();
  },true);
})();
